$size: var(--footer-size);

:root {
  --footer-size: 12rem;
  @media (min-width: 48rem) {
    --footer-size: 8rem;
  }
}

#footer {
  position: relative;
  margin-top: 2.5rem;
  padding: 2rem 0;
  width: 100%;
  display: flex;
  flex-shrink: 0;
  height: $size;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-top: 1px solid var(--color-gray-alt);

  @media (min-width: 48rem) {
    flex-direction: row;
    padding: 0;
  }

  a {
    color: var(--color-foreground);
    height: 5em;
    display: flex;
    flex-direction: row;
    align-items: center;
    text-decoration: none;

    img {
      position: relative;
      margin-right: 0.3em;
    }
  }
}

.openjsf img {
  height: 2em;
}

.ebay img {
  height: 1em;
  top: 0.1em;
}

.osi img {
  height: 1.5em;
}

.bold {
  font-weight: 500;
}
.light {
  font-weight: 300;
}

.separator {
  display: none;
  color: var(--color-gray-alt);
  height: 2lh;
  width: 2px;
  margin: 2rem;
  background-color: var(--color-gray-alt);
  position: relative;

  @media (min-width: 48rem) {
    display: block;
  }
}
